// Function to get category color from CSS variables
export const getCategoryColor = category => {
	// Create a temporary element to get the computed CSS variable
	const tempElement = document.createElement("div");
	tempElement.className = `category-${category}`;
	document.body.appendChild(tempElement);

	const computedStyle = window.getComputedStyle(tempElement);
	const color = computedStyle.getPropertyValue("--category-color").trim();

	document.body.removeChild(tempElement);

	// Fallback to default category color if specific color not found
	if (!color) {
		const defaultColor = window
			.getComputedStyle(document.body)
			.getPropertyValue("--default-category-color")
			.trim();
		return defaultColor || "#d4d4d4";
	}

	return color;
};

// Function to get income subcategory color from CSS variables
export const getIncomeSubCategoryColor = subCategory => {
	// Create a temporary element to get the computed CSS variable
	const tempElement = document.createElement("div");
	tempElement.className = `subCat-income-${subCategory}`;
	document.body.appendChild(tempElement);

	const computedStyle = window.getComputedStyle(tempElement);
	const color = computedStyle.getPropertyValue("--category-color").trim();

	document.body.removeChild(tempElement);

	// Fallback colors for income subcategories
	const fallbackColors = {
		salary: "#000000",
		// salary: "#3689e6",
		// lunchTickets: "#de3e80",
		// healthInsuranceRefund: "#f9c440",
		// socialSecurityRefund: "#715344",
		// other: "#a56de2"
	};

	return color || fallbackColors[subCategory] || "#d4d4d4";
};
